import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from '@tanstack/react-router';

import { router } from './App.router';
import { useLoadScript } from './App.hooks';

function App() {
	const classNames = ['App'];
	useLoadScript();
	return (
		<HelmetProvider>
			<div className={classNames.join(' ')}>
				<RouterProvider router={router} />
			</div>
		</HelmetProvider>
	);
}

export default App;
